export default [
	{
		modulo: 6,
		privilegio: 45,
		routerName: 'manutencao',
		routerPath: '/manutencao',
		componentName: 'Manutencao',
		componentPath: 'modules/layout/manutencao/manutencao/main'
	},
	{
		modulo: 6,
		privilegio: 87,
		routerName: 'modelo-padrao',
		routerPath: '/modelo-padrao',
		componentName: 'ModeloPadrao',
		componentPath: 'modules/layout/manutencao/modelo-padrao/main'
	},
	{
		modulo: 6,
		privilegio: 87,
		routerName: 'manutencao-visao-geral',
		routerPath: '/manutencao-visao-geral/:prefixo',
		componentName: 'ManutencaoVisalGeral',
		componentPath: 'modules/layout/manutencao/manutencao/visao-geral'
	},
	{
		modulo: 6,
		privilegio: 122,
		routerName: 'manutencao-disponibilidade',
		routerPath: '/manutencao-disponibilidade',
		componentName: 'ManutencaoDisponibilidade',
		componentPath: 'modules/layout/manutencao/disponibilidade/main'
	},
	{
		modulo: 6,
		privilegio: 136,
		routerName: 'manutencao-tipo-documentacao',
		routerPath: '/manutencao-tipo-documentacao',
		componentName: 'TipoDocumentacao',
		componentPath: 'modules/layout/manutencao/tipo-documentacao/main'
	},
	{
		modulo: 6,
		privilegio: 146,
		routerName: 'suprimento-aeronautico',
		routerPath: '/suprimento-aeronautico',
		componentName: 'SuprimentoAeronauticos',
		componentPath: 'modules/layout/manutencao/suprimentos-aeronauticos/main'
	},
	{
		modulo: 6,
		privilegio: 146,
		routerName: 'comprovante-solicitacao',
		routerPath: '/suprimento-aeronautico/comprovante-solicitacao/:id',
		componentName: 'ComprovanteSolicitacao',
		componentPath:
			'modules/layout/manutencao/suprimentos-aeronauticos/solicitacao/comprovante-solicitacao/main'
	},
	{
		modulo: 6,
		privilegio: 227,
		routerName: 'ordem-servico',
		routerPath: '/ordem-servico',
		componentName: 'OrdemServico',
		componentPath: 'modules/layout/manutencao/ordem-servico/main'
	},
	{
		modulo: 6,
		privilegio: 146,
		routerName: 'calendario-manutencao',
		routerPath: '/manutencao-calendario',
		componentName: 'ManutencaoCalendario',
		componentPath: 'modules/layout/manutencao/calendario/main'
	},
	{
		modulo: 6,
		privilegio: 0,
		routerName: 'controle-ferramental',
		routerPath: '/controle-ferramental',
		componentName: 'ControleFerramental',
		componentPath: 'modules/layout/manutencao/controle-ferramental/main'
	},
	{
		modulo: 6,
		privilegio: 300,
		routerName: 'controle-ferramental',
		routerPath: '/controle-ferramental',
		componentName: 'ControleFerramental',
		componentPath: 'modules/layout/manutencao/controle-ferramental/main'
	},
	{
		modulo: 0,
		privilegio: 0,
		routerName: 'discrepancias',
		routerPath: '/discrepancias',
		componentName: 'Discrepancias',
		componentPath: 'modules/layout/manutencao/discrepancia/main-rota'
	}
]
